import request from '@/utils/request';

/**
 * 升级
 * @param {*} params
 * @returns
 */
export function productUpdate({ id, data }) {
  return request({
    url: `/xzr_auth/${id}/upgrade/`,
    method: 'post',
    data,
  });
}

/**
 * 授权转移
 * @param {*} param0
 * @returns
 */
export function transfer({ id, data }) {
  return request({
    url: `/auth/${id}/transfer/`,
    method: 'post',
    data,
  });
}

/**
 * 试用延期
 * @param {*} param0
 * @returns
 */
export function trialExtension({ id, data }) {
  return request({
    url: `/auth/${id}/admin_delay/`,
    method: 'post',
    data,
  });
}

/**
 * 授权转移 小智产品
 * @param {*} param0
 * @returns
 */
export function xz_transfer({ id, data }) {
  return request({
    url: `/xzr_auth/${id}/transfer/`,
    method: 'post',
    data,
  });
}

/**
 * 试用延期  小智产品
 * @param {*} param0
 * @returns
 */
export function xz_trialExtension({ id, data }) {
  return request({
    url: `/xzr_auth/${id}/admin_delay/`,
    method: 'post',
    data,
  });
}

/**
 * 试用延期 - 模块
 * @param {*} param0
 * @returns
 */
export function trialExtensionModele({ id, data }) {
  return request({
    url: `/module_auth/${id}/admin_delay/`,
    method: 'post',
    data,
  });
}
/**
 * 试用延期 - 应用模块
 * @param {*} param0
 * @returns
 */
export function trialExtensionSuit({ id, data }) {
  return request({
    url: `/suit_auth/${id}/admin_delay/`,
    method: 'post',
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/xz_product.js